import { SvgCalendarOneDay, SvgLabelPrinting2X, SvgShop } from '@parcel2go/core-ui';
import { SvgDelete } from '@parcel2go/core-ui';
import { SvgLabelPrinting1X } from '@parcel2go/core-ui';
import { SvgLabelPrinting4X } from '@parcel2go/core-ui';
import { SvgLabelPrinting4X6 } from '@parcel2go/core-ui';
import { SvgLiveHelp } from '@parcel2go/core-ui';
import { SvgOrders } from '@parcel2go/core-ui';
import { SvgSmartSend } from '@parcel2go/core-ui';
import { SvgMapMarker } from '@parcel2go/core-ui';
import { SvgProtectionAdd } from '@parcel2go/core-ui';
import { SvgEdit } from '@parcel2go/core-ui';
import { SvgDuplicate } from '@parcel2go/core-ui';
import { SvgRefresh } from '@parcel2go/core-ui';
import { SvgParcel } from '@parcel2go/core-ui';
import SvgLabelPrinting4X4 from '../../../../../../components/icons/SvgLabelPrinting4X4';
import { SvgInstructions } from '@parcel2go/core-ui';

export function GetLinkLabelIcon(label: string) {
  switch (label) {
    // PAGES
    case 'HELPCENTRE_PAGE':
      return <SvgLiveHelp />;
    case 'ORDER-COMPLETE_PAGE':
      return <SvgOrders />;
    case 'TRACKING_PAGE':
      return <SvgMapMarker />;
    case 'CANCEL_ONCLICK':
    case 'CANCELLATION_PAGE':
      return <SvgDelete />;
    case 'ORDER-REBOOK_PAGE':
      return <SvgCalendarOneDay />;
    case 'ORDER-PROTECTION_PAGE':
      return <SvgProtectionAdd />;
    case 'RAISE-ENQUIRY_ONCLICK':
    case 'ORDER-OPENCLAIM_PAGE':
      return <SvgLiveHelp />;
    case 'ORDER-EDITDETAILS_PAGE':
      return <SvgEdit />;
    case 'ORDER-DROPSHOP_PAGE':
      return <SvgShop />;

    // DOWNLOADS
    case 'ORDER-INVOICE_DOWNLOAD':
      return <SvgCalendarOneDay />;

    // Labels: Mutiny Variants (ORDER Prefix Not Used for the Mutiny Variants)
    case 'LABELS-FOUR-BY-SIX_PRESIGNED':
    case 'LABELS-PACKING-FOUR-BY-SIX_PRESIGNED':
      return <SvgLabelPrinting4X6 />;

    case 'LABELS-A4-STANDARD-ECO_PRESIGNED':
    case 'LABELS-PACKING-A4-STANDARD-ECO_PRESIGNED':
      return <SvgLabelPrinting2X />;

    case 'LABELS-A4-STANDARD-PARCELS-ON-SEPARATE-PAGES_PRESIGNED':
    case 'LABELS-PACKING-A4-STANDARD-PARCELS-ON-SEPARATE-PAGES_PRESIGNED':
    case 'LABELS-A4-STANDARD_PRESIGNED':
    case 'LABELS-PACKING-A4-STANDARD_PRESIGNED':
      return <SvgLabelPrinting1X />;

    case 'LABELS-A4-STICKERS-FOUR-PER-PAGE_PRESIGNED':
    case 'LABELS-PACKING-A4-STICKERS-FOUR-PER-PAGE_PRESIGNED':
      return <SvgLabelPrinting4X />;

    case 'LABELS-A4-STICKERS-TWO-PER-PAGE_PRESIGNED':
    case 'LABELS-PACKING-A4-STICKERS-TWO-PER-PAGE_PRESIGNED':
      return <SvgLabelPrinting2X />;

    // Labels: Mutiny Legacy
    case 'ORDER-LABELS-4X6_PRESIGNED':
    case 'ORDER-LABELS-PACKING-4X6_PRESIGNED':
    case 'LABELS-4X6_PRESIGNED':
    case 'LABELS-PACKING-4X6_PRESIGNED':
      return <SvgLabelPrinting4X6 />;

    case 'ORDER-LABELS-4X4_PRESIGNED':
    case 'LABELS-4X4_PRESIGNED':
      return <SvgLabelPrinting4X4 />;

    case 'ORDER-LABELS-A4_PRESIGNED':
    case 'ORDER-LABELS-PACKING-A4_PRESIGNED':
    case 'LABELS-A4_PRESIGNED':
    case 'LABELS-PACKING-A4_PRESIGNED':
      return <SvgLabelPrinting1X />;

    case 'ORDER-LABELS-A4-4X6_PRESIGNED':
    case 'ORDER-LABELS-PACKING-A4-4X6_PRESIGNED':
    case 'LABELS-A4-4X6_PRESIGNED':
    case 'LABELS-PACKING-A4-4X6_PRESIGNED':
      return <SvgLabelPrinting4X />;

    // Labels: PublicAPI Variants
    case 'ORDER-LABELS-4X6_BASE64':
    case 'ORDER-LABELS-4X6_DOWNLOAD':
    case 'ORDER-LABELS-PACKING-4X6_DOWNLOAD':
    case 'LABELS-4X6_BASE64':
    case 'LABELS-4X6_DOWNLOAD':
    case 'LABELS-PACKING-4X6_DOWNLOAD':
      return <SvgLabelPrinting4X6 />;

    case 'ORDER-LABELS-4X4_BASE64':
    case 'ORDER-LABELS-4X4_HTML_BASE64':
    case 'ORDER-LABELS-4X4_DOWNLOAD':
    case 'LABELS-4X4_BASE64':
    case 'LABELS-4X4_HTML_BASE64':
    case 'LABELS-4X4_DOWNLOAD':
      return <SvgLabelPrinting4X4 />;

    case 'ORDER-LABELS-A4_BASE64':
    case 'ORDER-LABELS-A4_DOWNLOAD':
    case 'ORDER-LABELS-PACKING-A4_DOWNLOAD':
    case 'LABELS-A4_BASE64':
    case 'LABELS-A4_DOWNLOAD':
    case 'LABELS-PACKING-A4_DOWNLOAD':
      return <SvgLabelPrinting1X />;

    case 'ORDER-LABELS-A4-4X6_BASE64':
    case 'ORDER-LABELS-A4-4X6_DOWNLOAD':
    case 'ORDER-LABELS-PACKING-A4-4X6_DOWNLOAD':
    case 'LABELS-A4-4X6_BASE64':
    case 'LABELS-A4-4X6_DOWNLOAD':
    case 'LABELS-PACKING-A4-4X6_DOWNLOAD':
      return <SvgLabelPrinting4X />;

    case 'ORDER-PICKINGLIST_DOWNLOAD':
      return <SvgOrders />;

    // ONCLICKS
    case 'BUY-AGAIN_ONCLICK':
      return <SvgDuplicate />;
    case 'ARRANGE-RETURN_ONCLICK':
      return <SvgRefresh />;
    case 'MARKDISPATCHED_ONCLICK':
      return <SvgMapMarker />;
    case 'MARKPACKAGED_ONCLICK':
      return <SvgParcel />;
    case 'GOTO-BOOKED_ONCLICK':
      return <SvgOrders />;
    case 'GOTO-PICKANDPACK_ONCLICK':
      return <SvgLabelPrinting4X6 />;
    case 'GOTO-MANIFESTS':
      return <SvgInstructions />;

    default:
      return <SvgSmartSend />;
  }
}

export const DefaultLinkGroup = '';

export function GetLabelLinkGroupDescription(group: string) {
  switch (group) {
    case 'LabelWithPackingSlip':
      return 'Include printable packing slips with your labels';
    default:
      return group || DefaultLinkGroup;
  }
}

export function GetLinkLabelIconSrc(label: string) {
  switch (label) {
    // PAGES
    case 'HELPCENTRE_PAGE':
      return `/theme/icons/LiveHelp.svg`;
    case 'ORDER-COMPLETE_PAGE':
      return `/theme/icons/Orders.svg`;
    case 'TRACKING_PAGE':
      return `/theme/icons/MapMarker.svg`;
    case 'ORDER-DROPSHOP_PAGE':
      return `/theme/icons/MapMarker.svg`;
    case 'CANCEL_ONCLICK':
    case 'CANCELLATION_PAGE':
      return `/theme/icons/Delete.svg`;
    case 'ORDER-REBOOK_PAGE':
      return `/theme/icons/CalendarOneDay.svg`;
    case 'ORDER-PROTECTION_PAGE':
      return `/theme/icons/ProtectionAdd.svg`;
    case 'RAISE-ENQUIRY_ONCLICK':
    case 'ORDER-OPENCLAIM_PAGE':
      return `/theme/icons/LiveHelp.svg`;
    case 'ORDER-EDITDETAILS_PAGE':
      return `/theme/icons/Edit.svg`;

    // DOWNLOADS
    case 'ORDER-INVOICE_DOWNLOAD':
      return `/theme/icons/CalendarOneDay.svg`;

    // LABELS
    case 'ORDER-LABELS-4X6_BASE64':
    case 'ORDER-LABELS-4X6_DOWNLOAD':
    case 'ORDER-LABELS-PACKING-4X6_DOWNLOAD':
    case 'LABELS-4X6_BASE64':
    case 'LABELS-4X6_DOWNLOAD':
    case 'LABELS-PACKING-4X6_DOWNLOAD':
      return `/theme/icons/LabelPrinting4X6.svg`;
    case 'ORDER-LABELS-4X4_DOWNLOAD':
    case 'ORDER-LABELS-4X4_BASE64':
    case 'ORDER-LABELS-4X4_HTML_BASE64':
    case 'LABELS-4X4_BASE64':
    case 'LABELS-4X4_HTML_BASE64':
    case 'LABELS-4X4_DOWNLOAD':
      return `/theme/icons/LabelPrinting4X4.svg`;
    case 'ORDER-LABELS-A4_BASE64':
    case 'ORDER-LABELS-A4_DOWNLOAD':
    case 'ORDER-LABELS-PACKING-A4_DOWNLOAD':
    case 'LABELS-A4_BASE64':
    case 'LABELS-A4_DOWNLOAD':
    case 'LABELS-PACKING-A4_DOWNLOAD':
      return `/theme/icons/LabelPrinting1X.svg`;
    case 'ORDER-LABELS-A4-4X6_BASE64':
    case 'ORDER-LABELS-A4-4X6_DOWNLOAD':
    case 'ORDER-LABELS-PACKING-A4-4X6_DOWNLOAD':
    case 'LABELS-A4-4X6_BASE64':
    case 'LABELS-A4-4X6_DOWNLOAD':
    case 'LABELS-PACKING-A4-4X6_DOWNLOAD':
      return `/theme/icons/LabelPrinting4X.svg`;
    case 'ORDER-PICKINGLIST_DOWNLOAD':
      return `/theme/icons/Orders.svg`;

    // ONCLICKS
    case 'BUY-AGAIN_ONCLICK':
      return `/theme/icons/Duplicate.svg`;
    case 'ARRANGE-RETURN_ONCLICK':
      return `/theme/icons/Refresh.svg`;
    case 'MARKDISPATCHED_ONCLICK':
      return `/theme/icons/MapMarker.svg`;
    case 'MARKPACKAGED_ONCLICK':
      return `/theme/icons/Parcel.svg`;
    case 'GOTO-BOOKED_ONCLICK':
      return `/theme/icons/Orders.svg`;
    case 'GOTO-PICKANDPACK_ONCLICK':
      return `/theme/icons/LabelPrinting4X6.svg`;
    case 'GOTO-MANIFESTS':
      return `/theme/icons/Instructions.svg`;

    default:
      return `/theme/icons/SmartSend.svg`;
  }
}
